import { SvgIcon } from '@material-ui/core'
import React from 'react'

export default function BackIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d="M12,23.625C5.578,23.625 0.375,18.422 0.375,12C0.375,5.578 5.578,0.375 12,0.375C18.422,0.375 23.625,5.578 23.625,12C23.625,18.422 18.422,23.625 12,23.625ZM6.661,12.797L13.013,19.148C13.453,19.589 14.166,19.589 14.602,19.148L15.398,18.352C15.839,17.911 15.839,17.198 15.398,16.763L10.636,12L15.398,7.238C15.839,6.797 15.839,6.084 15.398,5.648L14.602,4.852C14.161,4.411 13.448,4.411 13.013,4.852L6.661,11.203C6.22,11.644 6.22,12.356 6.661,12.797Z" />
    </SvgIcon>
  )
}